import { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import { Skeleton } from "primereact/skeleton";
import { requestGetTrackingMonthlyReport } from "../../services/wisdomServices/trackingService";
import { getSessionItem } from "../../utils/helper/session";

function ManagerDashChart({ selectedProjectId }) {
  const user = getSessionItem("User");

  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getTrackedTime = async () => {
      setLoading(true);

      try {
        const list = selectedProjectId
          ? await requestGetTrackingMonthlyReport("project", 0, selectedProjectId)
          : await requestGetTrackingMonthlyReport("manager", user.id, 0);

        const labels = [];
        const tracked = [];
        const idle = [];
        const manualTime = [];
        const marked = [];

        for (const item of list || []) {
          labels.push(item.week);
          tracked.push(item.trackedTime);
          idle.push(item.idle);
          manualTime.push(item.manualTime);
          marked.push(item.marked);
        }

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue("--text-color");
        const textColorSecondary = documentStyle.getPropertyValue(
          "--text-color-secondary"
        );
        const surfaceBorder =
          documentStyle.getPropertyValue("--surface-border");

        setChartData({
          labels,
          datasets: [
            {
              label: "Tracked Time",
              backgroundColor: documentStyle.getPropertyValue("--blue-500"),
              borderColor: documentStyle.getPropertyValue("--blue-500"),
              data: tracked,
            },
            {
              label: "Idle",
              backgroundColor: documentStyle.getPropertyValue("--green-500"),
              borderColor: documentStyle.getPropertyValue("--green-500"),
              data: idle,
            },
            {
              label: "Manual Time",
              backgroundColor: documentStyle.getPropertyValue("--orange-500"),
              borderColor: documentStyle.getPropertyValue("--orange-500"),
              data: manualTime,
            },
            {
              label: "Marked",
              backgroundColor: documentStyle.getPropertyValue("--pink-500"),
              borderColor: documentStyle.getPropertyValue("--pink-500"),
              data: marked,
            },
          ],
        });

        setChartOptions({
          maintainAspectRatio: false,
          aspectRatio: 0.8,
          plugins: {
            legend: {
              labels: {
                color: textColor,
              },
            },
          },
          scales: {
            x: {
              ticks: {
                color: textColorSecondary,
                font: {
                  weight: 500,
                },
              },
              grid: {
                display: false,
                drawBorder: false,
              },
            },
            y: {
              ticks: {
                color: textColorSecondary,
              },
              grid: {
                color: surfaceBorder,
                drawBorder: false,
              },
            },
          },
        });
      } catch (error) {
        console.error(error);
        setChartData({});
      } finally {
        setLoading(false);
      }
    };

    getTrackedTime();
  }, [selectedProjectId, user.id]);

  if (loading) {
    return <Skeleton width="100%" height="18rem" borderRadius="12px" />;
  }

  return (
    <>
      <h5>T4W Project's Time</h5>
      <Chart type="bar" data={chartData} options={chartOptions} />
    </>
  );
}

export default ManagerDashChart;